module.exports = __webpack_public_path__ + "static/media/top_left_v10.4fba39be.png";